import * as React from 'react';

import {FunnelCard} from './funnel-card';
import {addFunnelRenderProperties} from './helpers';

import styles from './funnel-chart.module.css';

export type DistributionBarItem = {
    label: string;
    value: number;
    color: string;
};

export type FunnelChartItem = {
    title: string;
    value: number;
    valueSubtitle: string;
    valuePrefix?: string;
    tooltip?: string | React.ReactNode;
    isHoverable?: boolean;
    onClickFunnelBar?: () => void;
    onClickTitle?: () => void;
    distributionBar?: DistributionBarItem[];
};

type Props = {
    items: FunnelChartItem[];
    emptyState?: {
        shouldShow: boolean;
        component: React.ReactNode;
    };
};

export const FunnelChart = (props: Props) => {
    const funnelItems = React.useMemo(() => addFunnelRenderProperties(props.items), [props.items]);

    return (
        <div className={styles['funnel-chart-wrapper']}>
            {props.emptyState && props.emptyState.shouldShow && (
                <div className={styles['funnel-empty-state-overlay']}>
                    <div className={styles['funnel-empty-state-content']}>
                        {props.emptyState.component}
                    </div>
                </div>
            )}
            {funnelItems.map((item) => {
                return <FunnelCard key={item.title} item={item} />;
            })}
        </div>
    );
};
